type Action_Type = string;

// action to store the user data in the store after login
export const SET_USER_DETAILS: Action_Type = 'SET_USER_DETAILS';
export const UPDATE_USER_PROFILE_DETAILS: Action_Type =
  'UPDATE_USER_PROFILE_DETAILS';
export const UPDATE_USER_THEME_PREFERENCE: Action_Type =
  'UPDATE_USER_THEME_PREFERENCE';
export const RESET_USER_DETAILS: Action_Type = 'RESET_USER_DETAILS';
